import logo from './logo.svg';
import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, HashRouter } from 'react-router-dom';
import Footer from './components/Footer/Footer.js';
import Instructions from './components/Instructions/instructions.js';
import AdmissionForm from './components/AdmissionForm/AdmissionForm.js';
import RegistrationDetails from './components/RegistrationDetails/RegistrationDetails.js'
import { ToastContainer } from 'react-toastify';
import Registration from './components/Registration/Registration.js';
import SideBar from './components/SideBar/SideBar.js';
import Dashboard from './components/Dashboard/Dashboard.js';
import VerificationCandidate from './components/VerificationCandidate/VerificationCandidate.js';
import Courses from './components/Courses/Courses.js'
import UpgradeCourse from './components/UpgradeCourse/UpgradeCourse.js'
import Dashboard1 from './components/Dashboard/Dashboard1.js';
import HorizontalNavBar from './components/NavBar/HorizontalNavBar.js';
import Login from './components/Login/Login.js';
import Header from './components/Header/Header.js';
import Home from './components/Home/Home.js'
import AboutUs from './components/AboutUs/AboutUs.js';
import Pricing from './components/Pricing/Pricing.js';
import FAQ from './components/FAQ/FAQ.js';
import CoursesDetails from './components/CoursesDetails/CoursesDetails.js';
import CertificatedPages from './components/CertificatePages/CertificatePages.js'
import CertificatedPages1 from './components/CertificatePages/CertificatePages1.js'
import CertificatedPages2 from './components/CertificatePages/CertificatePages2.js'
import CertificatedPages3 from './components/CertificatePages/CertificatePages3.js'
import CertificatedPages4 from './components/CertificatePages/CertificatePages4.js'
import CertificatedPages5 from './components/CertificatePages/CertificatePages5.js'
import CertificatedPages6 from './components/CertificatePages/CertificatePages6.js'
import CertificatedPages7 from './components/CertificatePages/CertificatePages7.js'
import CertificatedPages8 from './components/CertificatePages/CertificatePages8.js'
import CertificatedPages9 from './components/CertificatePages/CertificatePages9.js'
import CertificatedPages10 from './components/CertificatePages/CertificatePages10.js'
import CertificatedPages11 from './components/CertificatePages/CertificatePages11.js'
import CertificatedPages12 from './components/CertificatePages/CertificatePages12.js'
import CertificatedPages13 from './components/CertificatePages/CertificatePages13.js'
import CertificatedPages14 from './components/CertificatePages/CertificatePages14.js'
import CertificatedPages15 from './components/CertificatePages/CertificatePages15.js'
import CertificatedPages16 from './components/CertificatePages/CertificatePages16.js'
import 'bootstrap/dist/css/bootstrap.min.css';
import ViewRegistrationDetails from './components/ViewRegistrationDetails/ViewRegistrationDetails.js';

import PageNotFound from './components/PageNotFound/PageNotFound.js'

import ScrollToTopOnMount from './components/ScrollToTopOnMount/ScrollToTopOnMount.js'
import axios from 'axios';
import ApplicationStatus from './components/ApplicationStatus/ApplicationStatus.js';
import LearnerDetails from './components/LearnerDetails/LearnerDetails.js';
import SessionDetails from './components/SessionDetails/SessionDetails.js';
import Admissions from './components/Admissions/Admissions.js';
import AdmissionList from './components/Admissions/AdmissionList.js';
import TrainingPartner from './components/TrainingPartner/TrainingPartner.js';
import Maintenance from './components/Maintenance/Maintenance.js';


function App() {
  const [hasScrollbar, setHasScrollbar] = useState(false);

  const checkScrollbar = () => {
    const hasVerticalScrollbar = document.documentElement.scrollHeight >= window.innerHeight;
    setHasScrollbar(hasVerticalScrollbar);
  };

  useEffect(() => {
    checkScrollbar();

    window.addEventListener('resize', checkScrollbar);
    return () => {
      window.removeEventListener('resize', checkScrollbar);
    };
  }, []);

  return (<>


    {/* <HorizontalNavBar/> */}
    <Router>
      <ScrollToTopOnMount />

      <Routes>
        {/* Maintenance Route - No Header/Footer */}
        <Route exact path="/maintenance" element={<Maintenance />} />

        {/* All other routes with Header/Footer */}
        <Route path="/*" element={
          <>
            <Header />
            <div className='bodyDiv'>
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/Coursesdetail" element={<CoursesDetails />} />
                <Route exact path="/CertificatedPages" element={< CertificatedPages />} />
                <Route exact path="/CertificatedPages1" element={< CertificatedPages1 />} />
                <Route exact path="/CertificatedPages2" element={< CertificatedPages2 />} />
                <Route exact path="/CertificatedPages3" element={< CertificatedPages3 />} />
                <Route exact path="/CertificatedPages4" element={< CertificatedPages4 />} />
                <Route exact path="/CertificatedPages5" element={< CertificatedPages5 />} />
                <Route exact path="/CertificatedPages6" element={< CertificatedPages6 />} />
                <Route exact path="/CertificatedPages7" element={< CertificatedPages7 />} />
                <Route exact path="/CertificatedPages8" element={< CertificatedPages8 />} />
                <Route exact path="/CertificatedPages9" element={< CertificatedPages9 />} />
                <Route exact path="/CertificatedPages10" element={< CertificatedPages10 />} />
                <Route exact path="/CertificatedPages11" element={< CertificatedPages11 />} />
                <Route exact path="/CertificatedPages12" element={< CertificatedPages12 />} />
                <Route exact path="/CertificatedPages13" element={< CertificatedPages13 />} />
                <Route exact path="/CertificatedPages14" element={< CertificatedPages14 />} />
                <Route exact path="/CertificatedPages15" element={< CertificatedPages15 />} />
                <Route exact path="/CertificatedPages16" element={< CertificatedPages16 />} />
            <Route exact path="/SideBar/upgrade-course" element={<UpgradeCourse />} key="38" />

                <Route exact path="/feeStructure" element={<Pricing />} />
                <Route exact path="/faq" element={<FAQ />} />
                <Route exact path="/about" element={<AboutUs />} />
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/instructions" element={<Instructions />} />
                <Route exact path="/registration" element={<Registration />} />
                <Route exact path="/SideBar" element={<SideBar />}>
                  <Route exact path='/SideBar/dashboard' element={<Dashboard />} />
                  <Route exact path='/SideBar/dashboard1' element={<Dashboard1 />} />
                  <Route exact path='/SideBar/applications' element={<VerificationCandidate />} />
                  <Route exact path='/SideBar/registration-details' element={<RegistrationDetails />} />
                  <Route exact path='/SideBar/my-courses' element={<Courses />} />
                  <Route exact path='/SideBar/registered-application' element={<ApplicationStatus />} />
                  <Route exact path='/SideBar/learner-details' element={<LearnerDetails />} />
                  <Route exact path="/SideBar/ViewRegistrationDetails" element={<ViewRegistrationDetails />} />
                  <Route exact path="/SideBar/admissions" element={<AdmissionList />} />
                  <Route exact path="/SideBar/new-admission" element={<Admissions />} />
                  <Route exact path="/SideBar/SessionDetails" element={<SessionDetails />} />
                  <Route exact path="/SideBar/training-partner" element={<TrainingPartner />} />
                  {/* <Route exact path="/SideBar/upgrade-course" element={<UpgradeCourse />} /> */}
                </Route>
              </Routes>
            </div>
            <div className={hasScrollbar ? 'no-scrollbar' : 'bottom-zero'}>
              {/* <Footer className="footer" /> */}
            </div>
            <Footer className="footer" />
          </>
        } />
      </Routes>
    </Router>
    <ToastContainer position='top-center' />

  </>
  );
}

export default App;
